import React from 'react';
import NoticeIcon from '../../components/NoticeIcon/NoticeIcon';
import styles from './Devices.module.scss';

/**
 * Rescues reasonably ask whether a text goes out from their own phone. It doesn't, and no one reads the
 * replies except STOP, so every place that sends one says so.
 */
export default function FiNumberNotice({ recipients = 'Adopters' }: { recipients?: 'Adopters' | 'Fosters' }) {
  return (
    <div className={`${styles.notice} ${styles.noticeInfo}`}>
      <NoticeIcon variant="info" />
      <div>
        <strong>Sent from a Fi number, not your phone.</strong> {recipients} can reply STOP to opt out. Other replies
        aren't seen by you or Fi.
      </div>
    </div>
  );
}
